import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Children, useCallback, useContext, useMemo, useState } from 'react'; // $FlowFixMe: untyped import

import { useMedia } from "../../../media/useMedia";
import Popover from '../../Common/Popover';
import Icon from '../../Common/Icon';
import { PopoverMenuWrapperContext } from './PopoverMenuWrapperContext';
import MenuItem from './MenuItem';
import MenuWrapper from './MenuWrapper';
import styles from './PopoverMenu.scss';

var PopoverMenu = function PopoverMenu(_ref) {
  var children = _ref.children,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottomRight' : _ref$position,
      _ref$eventType = _ref.eventType,
      eventType = _ref$eventType === void 0 ? ['click'] : _ref$eventType;
  var context = useContext(PopoverMenuWrapperContext);

  var _useMedia = useMedia(),
      xs = _useMedia.xs,
      sm = _useMedia.sm;

  var isTablet = xs || sm;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var isShow = useMemo(function () {
    if (context && !isTablet) {
      return context.isHover || isVisible;
    }

    return true;
  }, [context, isVisible, isTablet]);
  var onVisibleChange = useCallback(function (visible) {
    setIsVisible(visible);
  }, [setIsVisible]);
  var filteredChildren = Children.toArray(children).filter(function (child) {
    return child && child.props && child.type === MenuItem;
  }).map(function (child) {
    var handleClose = function handleClose() {
      child.props.onClick();
      setIsVisible(false);
    };

    return /*#__PURE__*/React.createElement(child.type, Object.assign({
      key: child.props.label
    }, child.props, {
      onClick: child.props.onClick ? handleClose : undefined
    }));
  });

  if (!isShow || !filteredChildren.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Popover, {
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.PopoverMenu
    }, filteredChildren),
    placement: position,
    trigger: eventType,
    onVisibleChange: onVisibleChange,
    visible: isVisible
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.PopoverMenu_iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles.PopoverMenu_iconWrapper_icon,
    name: "action-menu",
    color: "icon"
  })));
};

PopoverMenu.Item = MenuItem;
PopoverMenu.Wrapper = MenuWrapper;
export default PopoverMenu;